<div class="navbar-component">
    <div class="navbar-component__user-info">
        <div class="navbar-component__user-info__avatar">
            {{ nameInitials }}
        </div>
        <div
            class="navbar-component__user-info__dropdown-area"
            mat-button
            [matMenuTriggerFor]="modal"
        >
            <span>
                {{ fullName }}
            </span>
            <mb-icon [icon]="'select-down'" class="icon" size="sm"></mb-icon>
        </div>
    </div>

    <mat-menu #modal="matMenu" class="navbar-component__dropdown-component">
        <div
            class="navbar-component__dropdown-component__item"
            (click)="logout()"
        >
            <mb-icon icon="logout" size="sm"></mb-icon>
            <span>Logout</span>
        </div>
    </mat-menu>
</div>
